import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import { addTiming } from './config.js';
import organization from '_c/organization';
export default {
  components: {
    organization: organization
  },
  data: function data() {
    return {
      visible: false,
      formData: JSON.parse(JSON.stringify(addTiming.formData)),
      rules: addTiming.rules,
      orgVisible: false,
      defaultTime: '',
      pickerOptions: {
        // 只可选择当前年份及之前年份
        disabledDate: function disabledDate(time) {
          return time.getFullYear() > new Date().getFullYear();
        }
      },
      pickerOptionsSend: {
        // 当前系统时间+30分钟作为最早发送时间
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        }
      }
    };
  },
  methods: {
    init: function init(row) {
      this.formData = JSON.parse(JSON.stringify(addTiming.formData));
      if (row.id) {
        addTiming.formData.id = row.id;
        this.formData = Object.assign(this.formData, row);
        this.formData.staff_data = [].concat(_toConsumableArray(this.formData.department_list), _toConsumableArray(this.formData.staff_list));
        this.defaultTime = this.formData.send_time.split(' ')[1];
      }
      this.visible = true;
    },
    handleSendTime: function handleSendTime() {
      this.handleDefaultTime(this.formData.send_time);
    },
    handleDefaultTime: function handleDefaultTime(newValue) {
      var time = new Date(newValue).getTime();
      var date = new Date().getTime() + 60 * 1000 * 30;
      var nowDate = moment(date).format('yyyy-MM-DD HH:mm:ss');
      var dt = nowDate.split(' ');
      var st = newValue.split(' ')[1];
      if (newValue.split(' ')[0] === dt[0] && time < date) {
        // 是今天,选择 的时间开始为此刻的时分秒
        st = dt[1];
      }
      this.defaultTime = st;
      this.formData.send_time = newValue.split(' ')[0] + ' ' + st;
    },
    openOrg: function openOrg() {
      // 打开选择人员弹窗
      this.orgVisible = true;
    },
    handleSelectDepart: function handleSelectDepart(params) {
      // 选择人员
      this.formData.department_list = params.dept_list;
      this.formData.staff_list = params.staff_list;
      this.formData.staff_data = [].concat(_toConsumableArray(params.dept_list), _toConsumableArray(params.staff_list));
    },
    handleClose: function handleClose() {
      this.visible = false;
      delete addTiming.formData.id;
      this.formData = JSON.parse(JSON.stringify(addTiming.formData));
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
    },
    handleSave: function handleSave() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          var staff_id = _this.formateList(_this.formData.staff_list, 'staff_id');
          var department_list = _this.formateList(_this.formData.department_list, 'department_id');
          var data = {
            name: _this.formData.name,
            type: _this.formData.type,
            year: _this.formData.year,
            send_time: _this.formData.send_time,
            send_email_type: _this.formData.send_email_type,
            is_supplement: _this.formData.is_supplement,
            staff_id: staff_id.length ? staff_id : '',
            department_id: department_list.length ? department_list : ''
          };
          if (_this.formData.id) data.id = _this.formData.id;
          _this.$emit('handleSave', data);
        }
      });
    },
    formateList: function formateList(obj, key) {
      // 数据格式化
      return obj.map(function (item) {
        return item[key];
      });
    }
  }
};